
import { supabase } from "@/integrations/supabase/client";
import { DetectedLocation } from '../mappings/LocationMapping';
import { applyPriceFilter } from '../filters/PriceFilter';
import { applyFacilitiesFilter } from '../filters/FacilitiesFilter';
import { applyTravelDistanceFilter } from '../filters/TravelDistanceFilter';

export const handleCoastaBravaSearch = async (
  detectedLocation: DetectedLocation,
  priceConstraints: any,
  detectedFacilities: any,
  travelConstraints: any,
  query: string
) => {
  console.log('🏖️ === COSTA BRAVA REGION SEARCH - MAXIMUM BREADTH APPROACH ===');
  
  // Use the BROADEST possible search for Costa Brava
  let dbQuery = supabase
    .from('Complete feed')
    .select('*')
    .not('imageURL', 'is', null)
    .not('name', 'is', null)
    .eq('country', 'Spanje');

  // Apply Costa Brava filter across ALL text fields with maximum flexibility
  const costaBravaConditions = [
    'region.ilike.%Costa Brava%',
    'region.ilike.%costa brava%',
    'region.ilike.%COSTA BRAVA%',
    'city.ilike.%Costa Brava%',
    'city.ilike.%costa brava%',
    'city.ilike.%COSTA BRAVA%',
    'description.ilike.%Costa Brava%',
    'description.ilike.%costa brava%',
    'description.ilike.%COSTA BRAVA%',
    'name.ilike.%Costa Brava%',
    'name.ilike.%costa brava%',
    'name.ilike.%COSTA BRAVA%',
    'facilities.ilike.%Costa Brava%',
    'facilities.ilike.%costa brava%',
    'facilities.ilike.%COSTA BRAVA%',
    'categoryPath.ilike.%Costa Brava%',
    'categoryPath.ilike.%costa brava%',
    'categoryPath.ilike.%COSTA BRAVA%',
    // Also check for common Costa Brava locations
    'city.ilike.%Lloret%',
    'city.ilike.%Blanes%',
    'city.ilike.%Tossa%',
    'city.ilike.%Calella%',
    'city.ilike.%Pineda%',
    'city.ilike.%Roses%',
    'city.ilike.%L\'Estartit%',
    'city.ilike.%Platja d\'Aro%',
    'region.ilike.%Lloret%',
    'region.ilike.%Blanes%',
    'region.ilike.%Tossa%',
    'region.ilike.%Calella%',
    'region.ilike.%Pineda%',
    'region.ilike.%Roses%',
    'region.ilike.%L\'Estartit%',
    'region.ilike.%Platja d\'Aro%'
  ];

  dbQuery = dbQuery.or(costaBravaConditions.join(','));

  console.log('🏖️ Applied MAXIMUM BREADTH Costa Brava filter with all variations and cities');

  // Apply additional filters only if they exist
  if (priceConstraints) {
    console.log('💰 === APPLYING PRICE FILTERS TO COSTA BRAVA ===');
    dbQuery = applyPriceFilter(dbQuery, priceConstraints);
  }

  if (detectedFacilities) {
    console.log('🏨 === APPLYING FACILITIES FILTERS ===');
    dbQuery = applyFacilitiesFilter(dbQuery, detectedFacilities);
  }

  if (travelConstraints) {
    console.log('🛫 === APPLYING TRAVEL DISTANCE FILTERS ===');
    dbQuery = applyTravelDistanceFilter(dbQuery, travelConstraints);
  }

  // Execute query with very high limit to ensure we get everything
  const { data, error } = await dbQuery.limit(500);
  
  if (error) {
    console.error('❌ Costa Brava search error:', error);
    throw error;
  }
  
  console.log(`🏖️ Costa Brava search found ${data?.length || 0} results with maximum breadth`);
  
  // Return ALL results without any additional filtering for Costa Brava
  const allResults = data || [];
  console.log(`🏖️ Returning ALL ${allResults.length} Costa Brava results without any filtering`);
  
  return allResults;
};
